import { api } from './client.js'
import { endpoints } from './endpoints.js'

// Django SimpleJWT expects `{ username, password }`. We accept either
// an email-looking string or a username from the UI and forward it as
// `username` — Django's default User model authenticates by username.
export async function login(usernameOrEmail, password) {
  const { data } = await api.post(endpoints.login, {
    username: usernameOrEmail,
    password,
  })
  return data // { access, refresh }
}

export async function getMe() {
  const { data } = await api.get(endpoints.me)
  return data
}

// No server-side logout endpoint; client just clears its tokens.
export async function logout() {
  return null
}

/**
 * Public patient self-registration. Returns { access, refresh, user } so the
 * caller can store tokens and immediately treat the user as signed-in —
 * no follow-up login round-trip needed.
 *
 * @param {object} data
 * @param {string} data.first_name
 * @param {string} data.last_name
 * @param {string} data.sex                'male' | 'female' | 'other'
 * @param {string} data.password           min 8 chars
 * @param {string=} data.username          optional; derived if omitted
 * @param {string=} data.email
 * @param {string=} data.date_of_birth     ISO date, e.g. '1990-05-14'
 * @param {string=} data.phone_number
 * @param {string=} data.place_of_residence
 */
export async function registerPatient(data) {
  const { data: resp } = await api.post(endpoints.registerPatient, data)
  return resp
}

/**
 * Request a password reset link for the given email. Always resolves
 * with the same generic 200 message regardless of whether the email
 * exists — that's by design (don't leak which addresses are registered).
 */
export async function requestPasswordReset(email) {
  const { data } = await api.post(endpoints.passwordResetRequest, { email })
  return data
}

/**
 * Confirm a password reset using the uid + token from the email link.
 * Returns the success detail message; throws on invalid/expired token.
 */
export async function confirmPasswordReset({ uid, token, new_password }) {
  const { data } = await api.post(endpoints.passwordResetConfirm, {
    uid, token, new_password,
  })
  return data
}
